// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: relative;
  grid-column: 1;
  grid-row: 1;
  align-self: stretch;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  min-width: 0;
  background: #1a1a1a;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  border-right: 1px solid #1f2937;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
}

/* El ancho lo fija la columna del grid (--app-sidebar-width); no fijar 80/280px aquí */
.sidebar.collapsed {
  width: 100%;
}

.sidebar-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #1f2937;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-text {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.logo-collapsed {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  width: 100%;
}

.collapse-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.collapse-btn:hover {
  background: #374151;
  color: #ffffff;
}

.sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 12px;
}

.menu-item-container {
  display: block;
  margin-bottom: 4px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #9ca3af;
  text-decoration: none;
  padding: 12px 16px;
  margin-bottom: 4px;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.menu-item:hover {
  background: #374151;
  color: #ffffff;
}

.menu-item.active {
  background: #A61B34;
  color: #ffffff;
  font-weight: 500;
}

.menu-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 4px;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
  color: #9ca3af;
}

.menu-item-header:hover {
  background: #374151;
  color: #ffffff;
}

.menu-item-header.active {
  background: #A61B34;
  color: #ffffff;
}

.menu-label {
  flex: 1 1;
  font-size: 15px;
  font-weight: 400;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.arrow.expanded {
  transform: rotate(180deg);
}

.submenu {
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  padding-left: 12px;
  border-left: 1px solid #374151;
  margin-top: 4px;
}

.menu-item-level-1 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2px;
  color: #9ca3af;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.menu-item-level-1:hover {
  background: #374151;
  color: #ffffff;
}

.menu-item-level-1.active {
  background: rgba(166, 27, 52, 0.9);
  color: #ffffff;
  box-shadow: 0 4px 6px rgba(166, 27, 52, 0.2);
}

/* Asegurar que el container del menu-item-header sea de bloque */
.menu-item > .menu-item-header {
  display: flex;
  width: 100%;
}

.sidebar.collapsed .menu-item {
  padding: 12px;
  justify-content: center;
}

.sidebar.collapsed .menu-label,
.sidebar.collapsed .arrow {
  display: none;
}

.sidebar.collapsed .submenu {
  display: none;
}

/* Submenú colapsado: íconos desplegados hacia abajo */
.collapsed-submenu {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 0;
  margin-left: 8px;
  border-left: 2px solid #374151;
}

.collapsed-submenu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #9ca3af;
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;
  margin: 2px 0;
}

.collapsed-submenu-icon:hover {
  background: #374151;
  color: #ffffff;
}

.collapsed-submenu-icon.active {
  background: rgba(166, 27, 52, 0.9);
  color: #ffffff;
}

.sidebar.collapsed .menu-item-header {
  justify-content: center;
  padding: 12px;
}

.sidebar-footer {
  padding: 12px;
  border-top: 1px solid #1f2937;
}

.logout-btn {
  width: 100%;
  background: transparent;
  border: none;
  color: #9ca3af;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.logout-btn:hover {
  background: #374151;
  color: #ef4444;
}

.logout-icon {
  flex-shrink: 0;
}

.logout-text {
  white-space: nowrap;
  overflow: hidden;
}

.sidebar.collapsed .logout-btn {
  justify-content: center;
  padding: 12px;
}

.sidebar.collapsed .logout-text {
  display: none;
}

/* Scrollbar styling */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

/* Ancho del menú: lo controla --app-sidebar-width en la columna del grid */
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,uFAAuF;AACvF;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,4CAA4C;AAC9C;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E","sourcesContent":[".sidebar {\n  position: relative;\n  grid-column: 1;\n  grid-row: 1;\n  align-self: stretch;\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  min-width: 0;\n  background: #1a1a1a;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  border-right: 1px solid #1f2937;\n  overflow: hidden;\n  visibility: visible;\n  opacity: 1;\n}\n\n/* El ancho lo fija la columna del grid (--app-sidebar-width); no fijar 80/280px aquí */\n.sidebar.collapsed {\n  width: 100%;\n}\n\n.sidebar-header {\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  border-bottom: 1px solid #1f2937;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo-text {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.5px;\n}\n\n.logo-collapsed {\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: center;\n  width: 100%;\n}\n\n.collapse-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.collapse-btn:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 12px;\n}\n\n.menu-item-container {\n  display: block;\n  margin-bottom: 4px;\n}\n\n.menu-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #9ca3af;\n  text-decoration: none;\n  padding: 12px 16px;\n  margin-bottom: 4px;\n  border-radius: 8px;\n  transition: all 0.2s;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n}\n\n.menu-item:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.menu-item.active {\n  background: #A61B34;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.menu-item-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  margin-bottom: 4px;\n  border-radius: 8px;\n  transition: all 0.2s;\n  cursor: pointer;\n  color: #9ca3af;\n}\n\n.menu-item-header:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.menu-item-header.active {\n  background: #A61B34;\n  color: #ffffff;\n}\n\n.menu-label {\n  flex: 1;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.arrow {\n  margin-left: auto;\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.arrow.expanded {\n  transform: rotate(180deg);\n}\n\n.submenu {\n  display: flex;\n  flex-direction: column;\n  margin-left: 24px;\n  padding-left: 12px;\n  border-left: 1px solid #374151;\n  margin-top: 4px;\n}\n\n.menu-item-level-1 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 2px;\n  color: #9ca3af;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.menu-item-level-1:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.menu-item-level-1.active {\n  background: rgba(166, 27, 52, 0.9);\n  color: #ffffff;\n  box-shadow: 0 4px 6px rgba(166, 27, 52, 0.2);\n}\n\n/* Asegurar que el container del menu-item-header sea de bloque */\n.menu-item > .menu-item-header {\n  display: flex;\n  width: 100%;\n}\n\n.sidebar.collapsed .menu-item {\n  padding: 12px;\n  justify-content: center;\n}\n\n.sidebar.collapsed .menu-label,\n.sidebar.collapsed .arrow {\n  display: none;\n}\n\n.sidebar.collapsed .submenu {\n  display: none;\n}\n\n/* Submenú colapsado: íconos desplegados hacia abajo */\n.collapsed-submenu {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2px 0;\n  margin-left: 8px;\n  border-left: 2px solid #374151;\n}\n\n.collapsed-submenu-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  color: #9ca3af;\n  text-decoration: none;\n  transition: all 0.2s;\n  cursor: pointer;\n  margin: 2px 0;\n}\n\n.collapsed-submenu-icon:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.collapsed-submenu-icon.active {\n  background: rgba(166, 27, 52, 0.9);\n  color: #ffffff;\n}\n\n.sidebar.collapsed .menu-item-header {\n  justify-content: center;\n  padding: 12px;\n}\n\n.sidebar-footer {\n  padding: 12px;\n  border-top: 1px solid #1f2937;\n}\n\n.logout-btn {\n  width: 100%;\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  padding: 12px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-align: left;\n}\n\n.logout-btn:hover {\n  background: #374151;\n  color: #ef4444;\n}\n\n.logout-icon {\n  flex-shrink: 0;\n}\n\n.logout-text {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.sidebar.collapsed .logout-btn {\n  justify-content: center;\n  padding: 12px;\n}\n\n.sidebar.collapsed .logout-text {\n  display: none;\n}\n\n/* Scrollbar styling */\n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 3px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n/* Ancho del menú: lo controla --app-sidebar-width en la columna del grid */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
